import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Social Icon
 *
 * @file Social.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Social = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 23" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0003 -1.83588e-06C22.6571 -1.98073e-06 24.0003
        1.34314 24.0003 3L24.0003 14C24.0003 15.6569 22.6571 17
        21.0003 17L12.5508 17L7.76208 22.6313C7.4043 23.052 6.77319
        23.1031 6.35246 22.7453C6.12903 22.5553 6.00028 22.2768
        6.00028 21.9835L6.00028 17L3.00028 17C1.34342 17 0.000276027
        15.6569 0.000275882 14L0.00027492 3C0.000274776 1.34315
        1.34342 -1.17422e-07 3.00027 -2.62268e-07L21.0003
        -1.83588e-06ZM21.0003 2L3.00027 2C2.44799 2 2.00027 2.44772
        2.00027 3L2.00028 14C2.00028 14.5523 2.44799 15 3.00028
        15L8.00028 15L8.00028 19.2639L11.6262 15L21.0003 15C21.5526
        15 22.0003 14.5523 22.0003 14L22.0003 3C22.0003 2.44771
        21.5526 2 21.0003 2Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Social;
